import { render, staticRenderFns } from "./reset-password-step1.vue?vue&type=template&id=1340c29e&scoped=true&"
import script from "./reset-password-step1.vue?vue&type=script&lang=js&"
export * from "./reset-password-step1.vue?vue&type=script&lang=js&"
import style0 from "./reset-password-step1.vue?vue&type=style&index=0&id=1340c29e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1340c29e",
  null
  
)

/* custom blocks */
import block0 from "./reset-password-step1.vue?vue&type=custom&index=0&blockType=route"
if (typeof block0 === 'function') block0(component)

export default component.exports